import { isHTMLElement } from './getDropTargetsObjects';

export const getScrollContainer = (node?: Element | null) => {
  if (!isHTMLElement(node)) return;
  let currentNode: HTMLElement | null = node;
  const scrollContainers = [];
  while (currentNode) {
    const { overflow, overflowX, overflowY } =
      getComputedStyle(currentNode) ?? {};
    if (
      [overflow, overflowX, overflowY].some(
        prop => prop === 'scroll' || prop === 'auto'
      )
    ) {
      scrollContainers.push({
        node: currentNode,
        isScrollable:
          currentNode.scrollHeight > currentNode.offsetHeight ||
          currentNode.scrollWidth > currentNode.offsetWidth,
      });
    }
    currentNode = currentNode.parentElement;
  }
  const { node: bestCandidate } =
    scrollContainers.find(({ isScrollable }) => isScrollable) ?? {};
  if (bestCandidate) {
    return bestCandidate;
  }
  if (isRootScrollable()) {
    return document.documentElement;
  }

  return null;
};

const isRootScrollable = () => {
  const { documentElement } = document;
  return (
    documentElement.offsetHeight > window.innerHeight ||
    documentElement.offsetWidth > window.innerWidth
  );
};
